import StockSubsectionPlaceholder from "../../../components/StockSubsectionPlaceholder";

export default function CmvGeneralPage() {
  return (
    <StockSubsectionPlaceholder
      sectionPath="analisis"
      subsectionPath="cmv-general"
    />
  );
}
